import React, { useEffect } from "react";
import { LiveCarusel } from "./live-carusel";
import css from "./conditions.module.css";
import { portfolio } from "../../store/portfolioSlice/imeges";

export const allConditions = [
  {
    id: "0",
    img: portfolio.tasks[1].photo,
    name: "Индивидуальная",
    description: "",
    photoCount: "25+",
    time: "1-1.5 часа",
    price: "75р",
  },
  {
    id: "1",
    img: portfolio.tasks[28].photo,
    name: "Семейная",
    description: "",
    photoCount: "40+",
    time: "1.5 часа",
    price: "120р",
  },
  {
    id: "2",
    img: portfolio.tasks[34].photo,
    name: "LOVESTORY/РОДИТЕЛЬ+МАЛЫШ ",
    description: "",
    photoCount: "30+",
    time: "1.5 часа",
    price: "100р",
  },
];

export const Conditions = () => {
  useEffect(() => {
    document.title = "Условия, пакеты, сертификаты";
  }, []);
  return (
    <>
      <div className={css.conditions}>
        <LiveCarusel />
        <div>
          <h1 className={css.h1}>О сути моих фотографий:</h1>
          <p className={css.text}>
            Моя главная цель – снимать Вас искренних, раскрепощенных, свободных.
            Сутью каждого своего кадра я считаю именно человека. А каждый
            человек уже прекрасен: и легкая сутулость плеч, и шрамик на щеке, и
            хмурый взгляд – все, что для Вас естественно, для меня идеально.{" "}
          </p>
          <p className={css.text}>
            Скажу Вам честно, я могу спрятать Ваши веснушки, нарисовать десять
            бонусных сантиметров ногам или сделать из Вашего ребенка куклу, но
            не люблю этого. Этот мир слишком несовершенен и от этого так красив
            – с людьми так же. Я очень хочу, чтобы Вы смотрели на свои
            фотографии и видели себя, и радовались себе, а не гнались за
            навязанными кем-то «стандартами».
          </p>
          <p className={css.text}>
            <b>
              Будьте собой, я помогу рассказать именно Вашу историю – и она
              будет прекрасна, потому, что прекрасны Вы!
            </b>
          </p>
        </div>
        {allConditions.map(
          ({ id, img, name, description, photoCount, time, price }) => {
            if (id % 2 === 0) {
              return (
                <div key={id} className={css.container}>
                  <img className={css.img} alt="" src={img} />
                  <div className={css.description}>
                    <h2 className={css.h2}>{name}</h2>
                    <span className={css.descr}>{description}</span>
                    <p>
                      <b>Фотографий: </b>
                      {photoCount}
                    </p>
                    <p>
                      <b>Продолжительность до результата: </b>
                      {time}{" "}
                    </p>
                    <p>
                      <b>Цена: </b>
                      {price}
                    </p>
                  </div>
                </div>
              );
            } else
              return (
                <div key={id} className={css.container2}>
                  <div className={css.description}>
                    <h2 className={css.h2}>{name}</h2>
                    <span className={css.descr}>{description}</span>
                    <p>
                      <b>Фотографий: </b>
                      {photoCount}
                    </p>
                    <p>
                      <b>Продолжительность: </b>
                      {time}{" "}
                    </p>
                    <p>
                      <b>Цена: </b>
                      {price}
                    </p>
                  </div>
                  <img className={css.img} alt="" src={img} />
                </div>
              );
          }
        )}
        <div className={css.container2}>
          <div className={css.description}>
            <h2 className={css.h2}>ГОДОВОЙ ПАКЕТ </h2>
            <span className={css.descr}> </span>
            <span>3 семейные/lovestory/родитель+малыш съемки</span>
            <span>
              <b>Бонус – индивидульная фотосессия в подарок</b>
            </span>
            <p>срок действия — 1 год со дня покупки пакета услуг</p>
            <p>
              <b>Цена: 300р </b>
            </p>
            <ul className={css.spanlight}>
              <li>* Деньги за неиспользованные в течение срока действия пакета
              съемки НЕ возвращаются</li>
              <li>* Съемки из пакета можно дарить родным/близким</li>
            </ul>
          </div>
          <img className={css.img} alt="" src={portfolio.tasks[8].photo} />
        </div>
        <div className={css.container}>
          <img className={css.img} alt="" src={portfolio.tasks[32].photo} />
          <div className={css.description}>
            <h2 className={css.h2}>СЕРТИФИКАТ</h2>
            <span className={css.descr}> </span>
            <span className={css.textpad}>
              Любую съемку вы можете подарить своим друзьям или близким.
              Стоимость подарочного сертификата + 20р к стоимость фотосессии. В
              эту сумму входи:
            </span>
            <ul className={css.li}>
              <li>Именной подарочный сертификат;</li>
              <li>Декоративный конверт;</li>
              <li>Доставка в пределах МКАД и до 3км за МКАД.</li>
            </ul>
            <span className={css.spanlight}>
              Пожалуйста, убедитесь, что одариваемому человеку подходит мой
              стиль работы. Срок действия сертификата 3 месяца со дня покупки.
              Деньги за неиспользованный сертификат не возвращаются.
            </span>
          </div>
        </div>
        <div className={css.other}>
          <h2 className={css.otherInformation}><b>Общая информация:</b></h2>
        <ul className={css.ultam}>
              <li>Для подготовки к фотосессии я вышлю Вам чек-лист, чтобы этот процесс был для Вас максимально простым и удобным.</li>
              <li>В процессе подготовки к съемке я всегда на связи и с радостью отвечу на ваши вопросы.</li>
              <li>Продолжительность студийной съемки равняется времени аренды студии. Если же съемка проходит у Вас дома, на улице или в любом свободном пространстве, то во времени мы не ограничены. Обычно весь процесс занимает около 1−2 ч (исключение съемка торжеств и мероприятий). Я не ограничиваю время строго одним часом, и предпочитаю работать до результата.</li>
              <li>Помните, что результат съемки зависит не только от меня. Я всегда рекомендую выбирать комфортную для Вас одежду, подумать об удобном для Вас месте и времени для проведения съемки, так как Ваше настроение и позитив – главный залог хорошего результата.  </li>
              <li>Во время съемки я лишь слегка направляю Вас в действиях, но стараюсь не навязывать какие-то позы. В основном я стараюсь прожить с Вами несколько часов Вашего привычного или необычного дня и ловлю самые искренние эмоции. </li>
              <li>Соглашаясь на съемку, вы соглашаетесь на мой стиль обработки.</li>
              <li>При обработке я делаю очень лёгкую ретушь, но не произвожу масштабных изменений вашей внешности и окружающего пространства. </li>
              <li>В готовой серии могут присутствовать черно-белые кадры, которые я не дублирую в цвете. </li>
              <li>Отбор серии фотографий производится мной. </li>
              <li>Я не отдаю исходники. </li>
              <li>Я оставляю за собой право на публикацию фотографий в портфолио, в соцсетях и на сайте, использовать их для участия в конкурсах и выставках. </li>
              <li>Готовые фотографии Вам передаются через облачное хранилище.    </li>
              <li>Если съемка проводится в студии, то стоимость аренды дополнительно оплачивается заказчиком непосредственно администратору студии.</li>
              <li>Студию Вы бронируете сами на свое имя.</li>
              <li>Оплата моей работы производится в день съемки.</li>
              <li>Расходы на транспорт для выезда за пределы Минска оплачиваются дополнительно.</li>
              <li>Бронь даты осуществляется по предоплате 20р. В случае отмены съемки менее чем за 3 суток – бронь не возвращается.</li>
              <li>Ориентировочный срок готовности фотографий – 2 недели (но я стараюсь отдать фотографии как можно раньше).</li>
            </ul>
        </div>
        <div className={css.h2}>
          Если в перечне нет интересующего Вас вида съёмки, напишите или
          позвоните мне, мы сможем все обсудить.{" "}
        </div>
      </div>
    </>
  );
};
